import Swiper from 'swiper'

import {
  Autoplay,
  EffectFade,
  // FreeMode,
  Mousewheel,
  Navigation,
  Pagination,
  Thumbs,
} from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/mousewheel'
import 'swiper/css/effect-fade'

export default class Carousel {
  constructor(selector, options = {}, container) {
    const elements = container
      ? container.querySelectorAll(selector)
      : document.querySelectorAll(selector)

    // console.log(selector, elements, container)

    elements.forEach((element) => {
      const opts = { ...options }

      if (!opts.navigation)
        opts.navigation = {
          nextEl: element.querySelector('.swiper-button.is-next'),
          prevEl: element.querySelector('.swiper-button.is-prev'),
        }

      this.instance = new Swiper(element, {
        modules: [
          Autoplay,
          Navigation,
          Pagination,
          Mousewheel,
          // FreeMode,
          EffectFade,
          Thumbs,
        ],
        mousewheel: {
          forceToAxis: true,
        },
        ...opts,
      })
    })
  }
}
